module.exports = __webpack_public_path__ + "static/media/starburst.c96548fb.png";